module.exports = __webpack_public_path__ + "static/media/nature_3.aef42b3c.jpg";